import { useState } from "react";
import EnglishFlag from "../Assets/flags/en.svg";
import i18n, { languages } from "../i18n";
import LanguageSelectModal from "./LanguageSelectModal";

interface LanguageSelectorProps {}

const LanguageSelector: React.FunctionComponent<LanguageSelectorProps> = () => {
  const [showLanguageSelectModal, setShowLanguageSelectModal] =
    useState<boolean>(false);

  return (
    <>
      <div
        className="flex justify-center mb-4"
        onClick={() => setShowLanguageSelectModal(true)}
      >
        <div className="language-selector">
          <div 
            className="language-selector__image" 
            style={{ backgroundImage: `url("${languages.find((x) => x.key === i18n.language)?.flag ?? EnglishFlag}")` }}
          ></div>
          
          <div className="flex items-center gap-2">
            {languages.find((x) => x.key === i18n.language)?.shortName ?? "Eng"}
            <i className="icon-arrow-down"></i>
          </div>
        </div>
      </div>


      <LanguageSelectModal
        show={showLanguageSelectModal}
        onClose={() => setShowLanguageSelectModal(false)}
      />
    </>
  );
};

export default LanguageSelector;
